import { types } from '../../types/types';
import { handleErrorApi } from "../../helpers/randoms";
import CartillaMiOspedycService from "../../services/CartillaMiOspedycService";
import { finishSpinner, startSpinner } from '../ui/spinner';

export const getCartillaMiOspedyc = (idEspecialidad, idProvincia, idLocalidad = "", idRubro = "") => async (dispatch) => {
    try {
        dispatch({ type: types.cartillaMiOspedycTraerStart });
        dispatch(startSpinner())
        const response = await CartillaMiOspedycService.getCartilla(idEspecialidad, idProvincia, idLocalidad, idRubro);
        const body = await response.json();
        if (response.ok) {
            dispatch({
                type: types.cartillaMiOspedycTraerSuccess,
                payload: body,
            });
            dispatch(finishSpinner())
        } else {
            throw body;
        }
    } catch (error) {
        dispatch({ type: types.cartillaMiOspedycTraerError });
        dispatch(finishSpinner())
        handleErrorApi(
            dispatch,
            error,
            "Error al traer los datos de cartilla",
            "Ha ocurrido un error. Intente nuevamente"
        );
    }
};

export const getMiCartillaMiOspedyc = () => async (dispatch) => {
    try {
        dispatch({ type: types.miCartillaMiOspedycTraerStart });
        const response = await CartillaMiOspedycService.getMiCartilla();
        const body = await response.json();
        if (response.ok) {
            dispatch({
                type: types.miCartillaMiOspedycTraerSuccess,
                payload: body,
            });
        } else {
            throw body;
        }
    } catch (error) {
        dispatch({ type: types.miCartillaMiOspedycTraerError });
        handleErrorApi(
            dispatch,
            error,
            "Error al traer los datos de cartilla",
            "Ha ocurrido un error. Intente nuevamente"
        );
    }
};

export const agregarFavoritoCartilla = (idCartillaPrestadores) => async (dispatch) => {
    try {
        dispatch(startSpinner())
        const response = await CartillaMiOspedycService.agregarFavorito({idCartillaPrestadores});
        const body = await response.json();
        if (response.ok) {
            dispatch(finishSpinner())
            dispatch(getMiCartillaMiOspedyc())
        } else {
            throw body;
        }
    } catch (error) {
        dispatch(finishSpinner())
        handleErrorApi(
            dispatch,
            error,
            "Error al agregar favorito de cartilla",
            "Ha ocurrido un error. Intente nuevamente"
        );
    }
};

export const eliminarFavoritoCartilla = (idCartillaPrestadores) => async (dispatch) => {
    try {
        dispatch(startSpinner())
        const response = await CartillaMiOspedycService.eliminarFavorito(idCartillaPrestadores);
        const body = await response.json();
        if (response.ok) {
            dispatch(finishSpinner())
            dispatch(getMiCartillaMiOspedyc())
        } else {
            throw body;
        }
    } catch (error) {
        dispatch(finishSpinner())
        handleErrorApi(
            dispatch,
            error,
            "Error al eliminar favorito de cartilla",
            "Ha ocurrido un error. Intente nuevamente"
        );
    }
};